export const GRAPH_API_TYPE = {
  GET_GRAPH: "getGraph",
  ADD_GRAPH: "addGraph",
  UPDATE_GRAPH: "updateGraph",
  DELETE_GRAPH: "deleteGraph",
  DELETE_GRAPHS: "deleteGraphs",
  PUBLISH_GRAPH: "publishGraph",
  RUN_JOB: "runJob",
  RUN_JOBS: "runJobs",
  CANCEL_JOB: "cancelJob",
  LAST_JOB_EXECUTION: "jobStatus",
  JOB_EXECUTIONS: "jobExecutions",
  JOB_EXECUTION_LOGS: "jobExecutionLogs",
  JOB_EXECUTION_COUNT: "jobExecutionCount",
  GET_VERSIONS: "getVersions",
  RESTORE_VERSION: "restoreVersion",
  GET_PERMISSIONS: "getPermissions",
  GET_USER_PERMISSIONS: "getUserPermissions",
  UPDATE_PERMISSIONS: "updatePermissions",
  CLEAN_UP_RESULTS: "cleanUpResults",
  LOCK_GRAPH: "lockGraph",
  UNLOCK_GRAPH: "unlockGraph",
  GET_LOCK: "getLock",
  GET_RESULTS: "getResults",
  IMPORT_BPMN: "importBpmn",
  SHARE_GRAPH: "shareGraph",
  MOVE_GRAPHS: "moveGraphs",
  GET_GRAPH_ORDER: "getGraphOrder",
  UPDATE_GRAPH_ORDER: "updateGraphOrder",
  PREVIEW_ADHERENCE: 'previewAdherence',
  PREVIEW_ADHERENCE_STATE: 'previewAdherenceState',
  GET_TRACES: 'getTraces',
  START_DISCOVERY: 'startDiscovery',
  START_ITDM_DISCOVERY: 'startItdmDiscovery',
  START_TEST_DRIVEN_DISCOVERY: 'startTestDrivenDiscovery',
  VALIDATE_GRAPH_ATTRIBUTES: 'validateGraphAttributes',
};

export const LOGIN_API_TYPE = {
  BASIC_LOGIN: "basicLogin",
  SAML_LOGIN: "samlLogin",
  LOGOUT: "logout",
  GET_USER: "getUser",
  USERS: "users",
  GROUPS: "groups",
  ROLES: "roles",
  ADD_GROUP: "addGroup",
  EDIT_GROUP: "editGroup",
  DELETE_GROUP: "deleteGroup",
  EDIT_USER: "editUser",
  TRANSFER_OWNERSHIP: "transferOwnership",
  DELETE_USER: "deleteUser",
  INVITE_USER: "inviteUser",
  GET_GLOBAL_PERMISSIONS: "getGlobalPermissions",
  RESET_PASSWORD: "resetPassword",
  EMAIL_RESET: "emailReset",
  UPDATE_ROLE_USERS: "updateRoleUsers",
  GET_AUDIT_LOGS: "getAuditLogs",
  AUDIT_LOGS_COUNT: "auditLogsCount",
  GET_USER_PREFERENCES: "getUserPreferences",
  UPDATE_USER_PREFERENCE: "updateUserPreference",
};

export const WORKSPACE_API_TYPE = {
  GET_WORKSPACES: "getWorkspaces",
  ADD_WORKSPACE: "addWorkspace",
  UPDATE_WORKSPACE: "updateWorkspace",
  DELETE_WORKSPACE: "deleteWorkspace",
  GET_PERMISSIONS: "getPermissions",
  GET_USER_PERMISSIONS: "getUserPermissions",
  UPDATE_PERMISSIONS: "updatePermissions",
  SEARCH: "search",
};

export const DATA_API_TYPE = {
  GET_DATAPOOLS: "getDatapools",
  GET_DATAMODELS: "getDatamodels",
  GET_ACTIVITIES: "getActivities",
  GET_TABLES: "getTables",
  GET_TABLE_COLUMNS: "getTableColumns",
  GET_CASE_TABLES: "getCaseTables",
  RELOAD_DATAMODEL: "reloadDatamodel",
  PAC_GRAMMAR: "pacGrammar",
  GET_GRAPH_TABLE_OPTIONS: "getGraphTableOptions",
  TEMPLATES: "templates",
  VALIDATE_PQL: "validatePql",
  GET_CONTAINERS: "getContainers",
  GET_BLOBS: "getBlobs",
  GET_BLOB_COLUMNS: "getBlobCOlumns",
  GET_BLOB_ACTIVITIES: "getBlobActivities",
};

export const CHAT_API_TYPE = {
  ALL_CONVERSATIONS: "allConversations",
  GET_CONVERSATION: "getConversation",
  NEW_CONVERSATION: "newConversation",
  SEND_MESSAGE: "sendMessage",
  SEND_RATING: "sendRating",
  POLLING_THOUGHTS: "pollingThoughts",
  PROVIDE_FEEDBACK: "provideFeedback",
  GET_HEALTH_SUMMARY: "getHealthSummary",
  GET_CONTEXT_CACHE: "getContextCache",
  DELETE_CONTEXT_CACHE: "deleteContextCache",
  ADMIN_LOAD_ALL_CONVERSATIONS: "adminLoadAllConversations",
  IS_CHATBOT_ENABLED: "isChatbotEnabled",
  ADMIN_LOAD_ALL_EXAMPLES: "adminLoadAllExamples",
  ADMIN_UPDATE_EXAMPLE: "adminUpdateExample",
  ADMIN_DELETE_EXAMPLE: "adminDeleteExample",
};

export const CELONIS_CONTENT_API_TYPE = {
  GET_STUDIO_SPACES: "getStudioSpaces",
  GET_STUDIO_SPACES_PACKAGES: "getStudioSpacePackages",
  POST_PACKAGE_SPACE: "postPackageToSpace",
  GET_SPACE_URL: "getSpaceUrl",
  GET_EMS_URL: "getEmsUrl",
  GET_CELONIS_API: "getCelonisApi",
  UPDATE_CELONIS_API: "updateCelonisApi",
};

export const SLA_API_TYPE = {
  GET_CONFIG: "getConfig",
  GET_METRICS: "getMetrics",
  GET_INCIDENTS_COUNT: "getIncidentsCount",
};
